import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import { read } from "Helpers/LocalStorage";
import { useTranslation } from "react-i18next";
import { satc_factor } from "Constants/TableColumns";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import addNumToList from "Helpers/addNumToList";
import showNotify from "Helpers/Notify";
import PayTool from "./PayTool";
import cellEditFactory from "react-bootstrap-table2-editor";
import DialogHead from "Components/DialogHead/DialogHead";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import Input from "Components/Input/Input";

export default function Factors({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [data, setData] = useState([]);
  const [showPayTool, setShowPayTool] = useState(false);
  const [allNotZero, setAllNotZero] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [dataRequest, setDataRequest] = useState({});
  const [priceCalcLoading, setPriceCalcLoading] = useState(false);
  const [discount, setDiscount] = useState("");

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        GroupId: row.Id,
      };
      const response = await AccountService.getAccountGroupHistoryFactor(
        params
      );
      let err = StatusHandler(response);
      if (!err.isFail) {
        setData(addNumToList(response.data.Value, 1, 0));
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (e) {
      showNotify({ text: "getDataError", customClass: "error" });
      setShowDialog(false);
    }
  };

  const OnCellChanged = (oldValue, newValue, _row, column, done) => {
    if (JSON.parse(newValue) !== JSON.parse(oldValue)) {
      const _data = data;
      const updateNewValue = JSON.parse(newValue);
      _data[data.findIndex((obj) => obj.Id == _row.Id)].IsRequest =
        updateNewValue;
      setData(_data);
      setAllNotZero(
        !_data.map((item) => item.IsRequest).every((item) => item === false)
      );
    }
    done(false);
  };

  const priceCalcfunc = async (e) => {
    e.preventDefault();
    setPriceCalcLoading(true);
    let _req = [];
    data.map((items) => {
      items.IsRequest && _req.push(items.Id);
    });
    if (_req.length !== 0) {
      const _data = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        GroupId: row.Id,
        DiscountCode: discount,
        Factors: _req,
      };
      const response = await AccountService.postUpgradeCalculate(_data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setDataRequest(_data);
        setPaymentData(response.data.Value.Detail);
        setTimeout(() => {
          setPriceCalcLoading(false);
          setShowPayTool(true);
        }, 500);
      } else {
        setTimeout(() => {
          setPriceCalcLoading(false);
        }, 500);
      }
    } else {
      showNotify({ text: t("noDataInIncreaseFactors"), customClass: "error" });
      setPriceCalcLoading(false);
    }
  };

  const backFunc = (e) => {
    setShowPayTool(false);
    e === "submit" && onEnter();
  };

  const onExit = () => {
    setLoading(true);
    setShowPayTool(false);
    setShowDialog(false);
    setData([]);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="factors" />}
        icon={<Icons.Receipt />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        fullWidth
        maxWidth="sm"
      >
        <DialogHead
          text={<Translator id="factors" />}
          icon={<Icons.Receipt />}
          subtext={row.Name}
        />
        <DialogContent className="p-0 py-2">
          <div className="alert alert-warning px-1 py-2 mt-3">
            <Input
              name="discount"
              type="text"
              setValue={(e) => setDiscount(e.target.value)}
              disabled={priceCalcLoading || loading}
              placeholder={t("discount")}
              value={discount}
              label={<Translator id="discount" />}
            />
          </div>
          <RemoteTable
            data={data}
            loading={loading}
            columns={satc_factor}
            overflowScroll={true}
            noTitle={true}
            onTableChange={() => {}}
            showPagination={false}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              beforeSaveCell: (oldValue, newValue, row, column, done) =>
                OnCellChanged(oldValue, newValue, row, column, done),
            })}
          />
          {showPayTool && (
            <PayTool
              show={showPayTool}
              GroupName={row.Name}
              data={paymentData}
              dataRequest={dataRequest}
              backFunc={backFunc}
              GroupId={row.Id}
            />
          )}
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            title={<Translator id="priceCalculation" />}
            loading={priceCalcLoading}
            disabled={loading || !allNotZero}
            onClick={priceCalcfunc}
          />
          <MuiButton
            onClick={() => setShowDialog(false)}
            title={<Translator id="close" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
